import { BREAKER_CONTRACT_ADDRESS, GRIBBLE_CONTRACT_ADDRESS } from 'utils/contract';
import { raw } from './routes';

export const externalRoutes = {
  discord: raw('https://discord.gg/duskbreakers'),
  twitter: raw('https://twitter.com/duskbreakers'),
  openSea: raw('https://opensea.io/collection/duskbreakers'),
  instagram: raw('https://www.instagram.com/duskbreakersnft'),
  tiktok: raw('https://www.tiktok.com/@duskbreakers'),
  youtube: raw('https://www.youtube.com/channel/UCnAWj3_CYl30cga1k5fzG9g'),
  twitch: raw('https://www.twitch.tv/duskbreakers'),
  medium: raw('https://medium.com/metatheoryinc'),
  careers: raw('https://jobs.lever.co/Metatheory/'),
  viewLinks: {
    openSea: {
      duskbreakers: (id: number) => `https://opensea.io/assets/${BREAKER_CONTRACT_ADDRESS}/${id}`,
      eggs: (id: number) => `https://opensea.io/assets/${GRIBBLE_CONTRACT_ADDRESS}/${id}`,
    },
    looksRare: {
      duskbreakers: (id: number) =>
        `https://looksrare.org/collections/${BREAKER_CONTRACT_ADDRESS}/${id}`,
      eggs: (id: number) => `https://looksrare.org/collections/${GRIBBLE_CONTRACT_ADDRESS}/${id}`,
    },
    coinbaseNft: {
      duskbreakers: (id: number) =>
        `https://nft.coinbase.com/nft/ethereum/${BREAKER_CONTRACT_ADDRESS}/${id}`,
      eggs: (id: number) =>
        `https://nft.coinbase.com/nft/ethereum/${GRIBBLE_CONTRACT_ADDRESS}/${id}`,
    },
  },
};
